<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <base-button
        type="primary"
        round
        icon
        class="top-button-back"
        @click="$router.push('list')"
      >
        <i class="fa fa-arrow-left"></i>
      </base-button>
      <h2 class="text-eveer">Pass Types</h2>
    </div>
    <div></div>

    <div class="row">
      <div class="col-md-4">
        <card>
          <div>Add a new pass type</div>
          <form onSubmit="return false;">
            <div class="row">
              <div class="mt-4 col-md-12">
                <base-input
                  type="text"
                  label="Type"
                  maxlength="50%"
                  placeholder="Type"
                  v-model="envType"
                >
                </base-input>
              </div>
            </div>
            <div class="row" style="padding:30px"></div>
            <base-button
              native-type="submit"
              type="primary"
              value="Compares"
              class="btn-fill col-md-12"
              :disabled="loading"
              @click="addEnvironment()"
              >Create</base-button
            >
            <div class="row" style="padding:10px"></div>
          </form>
        </card>
      </div>
      <!--/div-->

      <!--div class="row mt-2"-->
      <div class="col-md-8">
        <card card-body-classes="table-full-width">
          <div>
            <el-table :data="queriedData">
              <el-table-column
                :min-width="200"
                align="left"
                label="Current Types"
              >
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>{{ props.row.envType }}</div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="200" align="right" l>
                <div slot-scope="props">
                  <button
                    class="btn btn-fill"
                    @click="deleteEnvironmentType(props.row)"
                  >
                    Delete
                  </button>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import { Modal, BaseAlert } from "src/components";

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      return this.tableData;
    }
  },
  data() {
    return {
      noDataMessage: "",
      loading: false,
      modals_classic: false,
      actions: [],
      envType: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      tableColumns: [
        {
          prop: "envType",
          label: "Current Types",
          minWidth: 200
        }
      ],
      tableData: [],
      searchedData: []
    };
  },
  async mounted() {
    this.loading = true;
    let apiResponse = await this.$apiService.getCall(
      "environment/get-environments"
    );
    this.tableData = apiResponse.apidata.Data || [];
    console.log(this.tableData);
    this.loading = false;
  },
  methods: {
    async addEnvironment() {
      if (!this.envType) {
        this.$apiService.notify("new pass type is mandatory");
        return;
      }
      this.loading = true;
      var envData = {
        envType: this.envType
      };
      var create_call = await this.$apiService.postCall(
        "environment/add-environment",
        envData
      );
      this.$apiService.notify("Type has been added.");

      let apiResponse = await this.$apiService.getCall(
        "environment/get-environments"
      );
      this.envType = "";
      this.tableData = apiResponse.apidata.Data || [];
      console.log(this.tableData);
      this.loading = false;
    },
    async deleteEnvironmentType(environmentInfo) {
      this.loading = true;
      let apiResponse = await this.$apiService.postCall(
        "environment/delete/" + environmentInfo._id
      );

      apiResponse = await this.$apiService.getCall(
        "environment/get-environments"
      );
      this.tableData = apiResponse.apidata.Data || [];
      this.loading = false;
    }
  }
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
.swal2-icon-content {
  font-size: inherit !important;
}
</style>
